import { render } from "./404.vue?vue&type=template&id=37ac1c95&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=37ac1c95&lang=less&scoped=true"

import exportComponent from "/Users/kk/ulu/dev/UstoreWebPayPC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ac1c95"]])

export default __exports__